<template>
  <div>
    <Head title="Users" />
    <div class="flex items-center justify-between mb-6">
      <h1 class="mb-8 text-3xl font-bold">Dias</h1>

      <search v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset" />        

      <Link class="btn-sky" href="add-day">
        <span>Crear dia</span>
      </Link>
    </div>

    <div class="overflow-x-auto">
      <table class="min-w-full bg-white shadow-md rounded-lg overflow-hidden">
        <thead>
          <tr class="bg-gray-200 text-gray-600 uppercase text-sm leading-normal">
            <th class="py-3 px-6 text-left">Nombre</th>
          </tr>
        </thead>
        <tbody class="text-gray-600 text-sm font-light">
          <tr v-for="day in days.data" :key="day.id" class="border-b border-gray-200 hover:bg-gray-100">
            <td class="py-1 px-6 text-left text-lg">
              <Link class="flex items-center px-6 py-2 focus:text-sky-600" :href="`/routes/sub-routes/edit-day/${day.id}`">
                {{ day.name }}
              </Link>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination class="mt-6" :links="days.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import Pagination from '@/Shared/Pagination'
import Search from '@/Shared/Search'
import throttle from 'lodash/throttle'
import pickBy from 'lodash/pickBy'
import mapValues from 'lodash/mapValues'

export default {
  components: {
    Head,
    Link,
    Pagination,
    Search,
  },
  layout: Layout,
  props: {
    filters: Object,
    days: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search, 
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/routes/sub-routes/list-day', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
  
}
</script>
